module.exports = __webpack_public_path__ + "static/media/spid-ico-circle-bb~bpKzRdOW.742f2939.svg";